import React from "react"
import { Heading } from "./.."
import FooterInfo from "./FooterInfo"

export default function Footer({ ...props }) {
  return (
    <>
      <div className="flex flex-col items-center bg-gray-900_02 py-12 md:py-5">
        <div className="container-xs mt-[50px] flex flex-col gap-[116px] md:gap-[87px] md:px-5 sm:gap-[58px]">
          <Heading
            size="headinglg"
            as="h2"
            className="text-[96px] font-semibold leading-[100%] tracking-[-1.92px] text-white-a700 md:text-[48px]"
          >
            Revolutionizing Portfolio Risk Management.
          </Heading>
          <FooterInfo />
        </div>
      </div>
     </>
  );
}